/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { OrganizationsList } from "organizations/components/OrganizationsList";
import { OrganizationTableList } from "organizations/components/OrganizationTableList";
import { OSActionButton, PageTitle } from "ui-widgets";
import { InviteWorkersButton } from "onboarding";
import { URLS } from "core/routes";

export const OrganizationsListingPage = () => {
  return (
    <React.Fragment>
      <PageTitle title="Organizations">
        <div className="table-top-actions">
          <OSActionButton actionStyle="add" to={URLS.setup}>
            Add Organization
          </OSActionButton>
          <InviteWorkersButton />
        </div>
      </PageTitle>

      <OrganizationsList
        renderOrganizationList={(organizations) => <OrganizationTableList organizations={organizations} />}
      />
    </React.Fragment>
  );
};
